<div (click)="onDisconnectedClicked()">
    <i class="dis-ellipse" [inlineSVG]="ellipsePath"></i>
    <i class="dis-icon" [ngClass]="iconClass" [inlineSVG]="iconPath"></i>
    <i class="dis-dot" *ngIf="!isCloud" [inlineSVG]="dotPath"></i>
    <div class="dis-device-name" *ngIf="!isCloud" [ngStyle]="{color: labelColor}">{{device?.name}}
    </div>
</div>